import React, { CSSProperties, useContext } from 'react'
import { CText } from 'app/components/Common/'
import { LoginHeaderWrap } from './styles'
import { ThemeContext } from 'theme/ThemeProvider'

interface IProps {
	label: string
	style?: CSSProperties
}

const LoginHeader = ({ label, style }: IProps) => {
	return (
		<LoginHeaderWrap>
			<span style={style}>{label}</span>
		</LoginHeaderWrap>
	)
}

export default React.memo(LoginHeader)
